import { render, staticRenderFns } from "./OrdenCompraNumero.vue?vue&type=template&id=4acd5b0f&"
import script from "./OrdenCompraNumero.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraNumero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports